<template>
  <v-app class="fundo">
    <v-container class="fill-height" fluid>
      <v-row align="center" class="mb-12 mt-n12" justify="center">
        <v-card class="borda" width="600">
          <v-card-text>
            <!-- FORMULÁRIO DE LOGIN -->
            <v-row v-if="!loadingValidSlug && validSlug">
              <v-col md="6">
                <v-row justify="center">
                  <v-img max-width="60%" src="../assets/Group.png" />
                </v-row>
                <v-row class="fil-height flex-column ma-0">
                  <v-col class="text-center">
                    <span class="black--text title font-weight-bold"
                      >Bem-Vindo!</span
                    >
                  </v-col>
                  <v-col class="mt text-center">
                    <v-avatar size="100" tile v-if="clube.clube_logotipo">
                      <v-img
                        height="100"
                        contain
                        :src="clube.clube_logotipo"
                        :lazy-src="clube.clube_logotipo"
                      />
                    </v-avatar>
                    <v-avatar
                      size="100"
                      color="#283480"
                      v-if="!clube.clube_logotipo"
                    >
                      <span class="white--text headline text-uppercase">{{
                        clube.clube_nome_comercial.charAt(0)
                      }}</span>
                    </v-avatar>
                  </v-col>
                  <!-- <v-col class="mt-3 text-center">
                    <v-btn rounded class="white--text" to="/" color="#283480">Criar conta</v-btn>
                  </v-col>-->
                </v-row>
              </v-col>
              <v-col md="6">
                <span
                  v-if="!recuperarSenha"
                  class="black--text title font-weight-bold"
                  >Login</span
                >
                <span v-else class="black--text title font-weight-bold"
                  >Recuperar conta</span
                >
                <br />
                <span class="black--text" v-if="!recuperarSenha"
                  >Efetue o login para acessar o sistema</span
                >
                <span class="black--text" v-else
                  >Informe o E-mail para redefinir sua senha</span
                >
                <form @submit.prevent="login" v-if="!recuperarSenha">
                  <v-text-field
                    class="mb-n4 mt-5"
                    dense
                    solo
                    flat
                    outlined
                    type="email"
                    label="E-mail"
                    name="email"
                    required
                    v-model="form.usuario_email"
                  ></v-text-field>
                  <v-text-field
                    dense
                    solo
                    flat
                    outlined
                    label="Senha"
                    type="password"
                    name="senha"
                    required
                    v-model="form.usuario_senha"
                  ></v-text-field>
                  <v-row align="center" justify="space-between" no-gutters>
                    <v-btn
                      color="#283480"
                      rounded
                      class="white--text mt-n2"
                      :disabled="loading"
                      :loading="loading"
                      type="submit"
                      >Entrar</v-btn
                    >
                    <v-btn
                      color="#283480"
                      rounded
                      outlined
                      x-small
                      class="black--text overline mt-n2"
                      :disabled="loading"
                      @click="
                        (recuperarSenha = !recuperarSenha),
                          (recuperar_senha_email = '')
                      "
                    >
                      <span v-if="recuperarSenha">Cancelar</span>
                      <span v-else>recuperar senha</span>
                    </v-btn>
                  </v-row>
                  {{ errorMessage }}
                </form>
                <form @submit.prevent="sendMailRecuperarSenha" v-else>
                  <v-text-field
                    dense
                    solo
                    flat
                    v-model="recuperar_senha_email"
                    outlined
                    label="E-mail"
                    required
                    type="email"
                    name="recuperar"
                    v-bind:class="{
                      'mt-n4 escondido': !recuperarSenha,
                      'mt-5': recuperarSenha,
                    }"
                  ></v-text-field>
                  <v-row align="center" justify="space-between" no-gutters>
                    <v-btn
                      color="#283480"
                      rounded
                      class="white--text mt-n2"
                      :disabled="loading"
                      :loading="loading"
                      type="submit"
                      >Enviar email</v-btn
                    >
                    <v-btn
                      color="#283480"
                      rounded
                      outlined
                      x-small
                      class="black--text overline mt-n2"
                      :disabled="loading"
                      :loading="loading"
                      @click="
                        (recuperarSenha = !recuperarSenha),
                          (recuperar_senha_email = '')
                      "
                    >
                      <span v-if="recuperarSenha">Cancelar</span>
                      <span v-else>recuperar senha</span>
                    </v-btn>
                  </v-row>
                </form>
              </v-col>
            </v-row>

            <!-- CLUBE NÃO ENCONTRADO -->
            <v-row
              v-if="!loadingValidSlug && !validSlug"
              class="py-10 text-center"
            >
              <v-col md="12" class="text-center">
                <label>Clube não encontrado.</label>
              </v-col>
            </v-row>

            <!-- LOADING VALIDAR SLUG-->
            <v-row v-if="loadingValidSlug" class="py-10 text-center">
              <v-col md="12" class="text-center">
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- MODAL TERMOS DE USO -->
        <v-dialog v-model="dialog_termos" width="800px">
          <v-card flat class="borda" height="100%">
            <v-card-title>
              <span class="headline">Termos de Uso</span>
            </v-card-title>
            <v-card-text>
              <!-- <embed width='100%' height='700' src='/documents/TERMO_DE_CONFIDENCIALIDADE.pdf' type='application/pdf' /> -->
              <a :href="link_termos" target="_blank" v-if="link_termos"
                >Clique aqui para ler os termos</a
              >
            </v-card-text>
            <v-card-actions class="ma-0">
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog_termos = false"
                >Recusar</v-btn
              >
              <v-btn color="green darken-1" text @click="continuarTermos()"
                >Aceitar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- MODAL SELEÇÃO DE CLUBES -->
        <v-dialog v-model="dialog_clubes" max-width="650">
          <v-card class="borda" flat :loading="loadingContinuar">
            <v-card-title>
              <div class="ml-1" v-if="user">
                <span class="headline">
                  Olá
                  <b>{{ user.usuario_nome }}</b
                  >, selecione um clube
                </span>
              </div>
              <span class="headline ma-3"></span>
              <v-spacer></v-spacer>
              <v-btn icon text @click="close()">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-2">
              <v-container v-if="user">
                <v-row dense>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(item, index) in user.clubes"
                      :key="index"
                      :readonly="true"
                    >
                      <v-expansion-panel-header>
                        <v-row style="flex: 0 1 auto" class="mr-2">
                          <v-avatar size="32" v-if="item.clube_logotipo">
                            <img
                              :src="item.clube_logotipo"
                              :alt="item.clube_logotipo"
                            />
                          </v-avatar>
                          <v-avatar
                            size="32"
                            color="#283480"
                            v-if="!item.clube_logotipo"
                          >
                            <span class="white--text headline text-uppercase">{{
                              item.clube_nome_comercial.charAt(0)
                            }}</span>
                          </v-avatar>
                        </v-row>
                        <span style="flex: 0 1 auto">{{
                          item.clube_nome_comercial
                        }}</span>
                        <v-row style="flex: 0 1 auto">
                          <v-btn
                            @click="continuarLogin(item)"
                            class="ma-2 ml-5"
                            rounded
                            x-small
                            outlined
                            color="primary"
                            >Acessar</v-btn
                          >
                        </v-row>
                        <template v-slot:actions>
                          <v-icon></v-icon>
                        </template>
                      </v-expansion-panel-header>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";

export default {
  props: ["clubeSlug"],
  data() {
    return {
      form: {
        usuario_email: "",
        usuario_senha: "",
      },
      recuperar_senha_email: "",
      errorMessage: "",
      user: "",
      loading: false,
      loadingContinuar: false,
      loadingValidSlug: true,
      dialog_clubes: false,
      dialog_termos: false,
      validSlug: false,
      clube: "",
      link_termos: "",
      recuperarSenha: false,
      podelogar: true
    };
  },

  created() {
    if (this.clubeSlug) {
      this.validarSlug();
    } else {
      this.loadingValidSlug = false;
      this.validSlug = false;
      this.clube = "";
    }
    this.getConfigs();
  },

  methods: {
    diasRestante(user_token) {
      Api.get(`/clubes/getVencimentoLink/${this.clubeSlug}`)
        .then((response) => {
          if (response.data.error) {
            this.podelogar = false;
            for (let i = 0; i < response.data.tokens.length; i++) {
              if (user_token === response.data.tokens[i].token) {
                setTimeout(() => {
                  window.open(response.data.link, "_blank");
                }, 2000);
              }
              this.$toast.warning("Clube está com o pagamento atrasado.");
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    close() {
      this.dialog_clubes = false;
    },
    getHash(item) {
      let url =
        Api.getApUrl() + "/clubes/imagem/show?img=" + item.clube_logotipo_hash;
      return url;
    },
    login() {
      this.loading = true;
      if (this.clube.clube_token) {
        Api.post("/login/" + this.clube.clube_token, this.form)
          .then((response) => {
            this.loading = false;
            if (response.data.error) {
              this.$toast.error(response.data.error);
            } else {
              this.modulos_login = response.data.clubes[0].modulos;
              this.errorMessage = "";
              this.user = response.data;
              if (!this.user.usuario_termos) {
                this.dialog_termos = true;
                return false;
              }
              if (this.user.clubes.length > 1) {
                this.dialog_clubes = true;
              } else {
                this.diasRestante(this.user.usuario_token);
                if (this.podelogar) {
                  localStorage.setItem(
                    "token",
                    this.user.clubes[0].clube_token
                  );
                  localStorage.setItem("tkn", "1");
                  localStorage.setItem(
                    "clubes",
                    JSON.stringify(this.user.clubes)
                  );
                  localStorage.setItem("user-token", this.user.usuario_token);
                  localStorage.setItem(
                    "clube-atual",
                    JSON.stringify(this.user.clubes[0])
                  );

                  if (!this.modulos_login.some((item) => item.id_modulo == 1)) {
                    this.$router.push({ name: "Meu_titulo" });
                  } else {
                    this.$router.push({ name: "Dashboard" });
                  }
                }
              }
            }
          })
          .catch((err) => {
            this.loading = false;
            throw err;
          });
      } else {
        this.loading = false;
      }
    },
    sendMailRecuperarSenha() {
      if (
        // regex verifica se email é válido ou não
        /^(([^<>()\\.,;:ç~\s@"]+(\.[^<>()\\.,;:ç~\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
          this.recuperar_senha_email
        )
      ) {
        this.loading = true;
        let infos = {
          fk_id_clube: this.clube.id_clube,
          usuario_email: this.recuperar_senha_email,
        };
        Api.post("/redefinir-conta", infos)
          .then((response) => {
            if (!response.data.errors) {
              this.$toast.success(response.data.success);
              setTimeout(() => {
                this.$toast.info("Acesse seu email para redefinir sua senha.");
              }, 1000);
            } else {
              this.$toast.warning(response.data.errors);
            }
            this.recuperarSenha = false;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.$toast.error(err);
            throw err;
          });
      } else {
        this.$toast.warning("Informe um e-mail válido.");
      }
    },
    continuarTermos() {
      Api.post(`/usuario-termos/${this.user.id_usuario}`)
        .then((response) => {
          if (response) {
            this.dialog_termos = false;
          }
          this.dialog_termos = false;
          if (this.user.clubes.length > 1) {
            this.dialog_clubes = true;
          } else {
            localStorage.setItem("token", this.user.clubes[0].clube_token);
            localStorage.setItem("clubes", JSON.stringify(this.user.clubes));
            localStorage.setItem("user-token", this.user.usuario_token);
            localStorage.setItem("tkn", "1");
            localStorage.setItem(
              "clube-atual",
              JSON.stringify(this.user.clubes[0])
            );
            if (!this.modulos_login.some((item) => item.id_modulo == 1)) {
              this.$router.push({ name: "Meu_titulo" });
            } else {
              this.$router.push({ name: "Dashboard" });
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },

    continuarLogin(item) {
      this.loadingContinuar = true;
      if (item.clube_token) {
        localStorage.setItem("tkn", "1");
        localStorage.setItem("clubes", JSON.stringify(this.user.clubes));
        localStorage.setItem("token", item.clube_token);
        localStorage.setItem("user-token", this.user.usuario_token);
        localStorage.setItem("clube-atual", JSON.stringify(item));
        //this.dialog_clubes = false;
        if (!item.modulos.some((id) => id.id_modulo == 1)) {
          this.$router.push({ name: "Meu_titulo" });
        } else {
          this.$router.push({ name: "Dashboard" });
        }
      }
    },

    validarSlug() {
      this.loadingValidSlug = true;
      Api.get(`/clubes/valid-slug/${this.clubeSlug}`)
        .then((response) => {
          this.loadingValidSlug = false;
          if (response.data.error) {
            this.validSlug = false;
          } else {
            this.validSlug = true;
            this.clube = response.data;
          }
        })
        .catch((err) => {
          this.loadingValidSlug = false;
          this.clube = "";
          throw err;
        });
    },

    getConfigs() {
      Api.get(`/get-configs`)
        .then((response) => {
          if (response.data) {
            this.link_termos = response.data.config_link_termos;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fundo {
  background-image: url("../assets/fundo.jpg") !important;
}
</style>